import { createContext, useContext, useState } from "react";

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);
  // alert = { type: "success" | "danger" | "warning", message }

  const showAlert = (type, message, duration = 3000) => {
    setAlert({ type, message });

    if (duration > 0) {
      setTimeout(() => setAlert(null), duration);
    }
  };

  const clearAlert = () => setAlert(null);

  return (
    <AlertContext.Provider value={{ alert, showAlert, clearAlert }}>
      {children}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  const ctx = useContext(AlertContext);
  if (!ctx) throw new Error("useAlert must be used inside AlertProvider");
  return ctx;
}
